const settings = {
  env: {},
}

window.settings = settings

const envs = process.env

const jsonEnvs = {
  REACT_APP_VERSION: 'undefined',
  REACT_APP_WAIT_TIME_FOR_STATUS_SECONDS: 60,

  REACT_APP_POSTHOG_API_HOST: '',
  REACT_APP_POSTHOG_API_KEY: '',
}

Object.entries(jsonEnvs).forEach(([key, defaultValue]) => {
  settings.env[key] = defaultValue
  try {
    const json = JSON.parse(envs[key])
    if (json !== undefined && json !== null && json !== `__${key}__`) {
      settings.env[key] = json
    }
  } catch (e) {
    if (envs[key] && envs[key] !== `__${key}__`) {
      settings.env[key] = envs[key]
    }
  }
})

export {settings}
